export const forumStatusOptions = [
  { label: "待审核", value: "pending", type: "warning" },
  { label: "已通过", value: "approved", type: "success" },
  { label: "已拒绝", value: "rejected", type: "danger" },
  { label: "已隐藏", value: "deleted", type: "info" },
];

export const reportStatusOptions = [
  { label: "待处理", value: "pending", type: "warning" },
  { label: "处理中", value: "processing", type: "primary" },
  { label: "已解决", value: "resolved", type: "success" },
  { label: "已驳回", value: "rejected", type: "info" },
];

export const userStatusOptions = [
  { label: "正常", value: "normal", type: "success" },
  { label: "封禁", value: "banned", type: "danger" },
  { label: "停用", value: "disabled", type: "info" },
];

export function optionLabel(options, value) {
  const item = options.find((option) => option.value === value);
  return item ? item.label : value || "-";
}

export function optionType(options, value) {
  const item = options.find((option) => option.value === value);
  return item ? item.type : "";
}

export function formatTime(value) {
  if (!value) {
    return "-";
  }
  const numberValue = Number(value);
  if (!numberValue) {
    return "-";
  }
  const date = new Date(numberValue > 100000000000 ? numberValue : numberValue * 1000);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

export function normalizeImages(value) {
  if (!value) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value !== "string") {
    return [];
  }
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return value ? [value] : [];
  }
}

export function prettyJson(value) {
  if (!value) {
    return "";
  }
  if (typeof value !== "string") {
    return JSON.stringify(value, null, 2);
  }
  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch (e) {
    return value;
  }
}

export function isSuccess(res) {
  return res && res.data && res.data.code === 1001;
}
